/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TeamSearchCriteriaDto = {
    voivodeship?: TeamSearchCriteriaDto.voivodeship;
    county?: TeamSearchCriteriaDto.county;
    tier?: string;
    teamType?: TeamSearchCriteriaDto.teamType;
    userType?: TeamSearchCriteriaDto.userType;
    searchMode?: string;
    maxDistanceKm?: number;
    pitchLatitude?: number;
    pitchLongitude?: number;
    scheduleId?: number;
};
export namespace TeamSearchCriteriaDto {
    export enum voivodeship {
        DOLNOSLASKIE = 'DOLNOSLASKIE',
        KUJAWSKO_POMORSKIE = 'KUJAWSKO_POMORSKIE',
        LUBELSKIE = 'LUBELSKIE',
        LUBUSKIE = 'LUBUSKIE',
        LODZKIE = 'LODZKIE',
        MALOPOLSKIE = 'MALOPOLSKIE',
        MAZOWIECKIE = 'MAZOWIECKIE',
        OPOLSKIE = 'OPOLSKIE',
        PODKARPACKIE = 'PODKARPACKIE',
        PODLASKIE = 'PODLASKIE',
        POMORSKIE = 'POMORSKIE',
        SLASKIE = 'SLASKIE',
        SWIETOKRZYSKIE = 'SWIETOKRZYSKIE',
        WARMINSKO_MAZURSKIE = 'WARMINSKO_MAZURSKIE',
        WIELKOPOLSKIE = 'WIELKOPOLSKIE',
        ZACHODNIOPOMORSKIE = 'ZACHODNIOPOMORSKIE',
    }
    export enum county {
        WROCLAW = 'WROCLAW',
        JELENIA_GORA = 'JELENIA_GORA',
        LEGNICA = 'LEGNICA',
        WALBRZYCH = 'WALBRZYCH',
        BOLESLAWIECKI = 'BOLESLAWIECKI',
        DZIERZONIOWSKI = 'DZIERZONIOWSKI',
        GLOGOWSKI = 'GLOGOWSKI',
        GOROWSKI = 'GOROWSKI',
        JAWORSKI = 'JAWORSKI',
        JELENIOGORSKI = 'JELENIOGORSKI',
        KAMIENNOGORSKI = 'KAMIENNOGORSKI',
        KLODZKI = 'KLODZKI',
        LEGNICKI = 'LEGNICKI',
        LUBANSKI = 'LUBANSKI',
        LUBINSKI = 'LUBINSKI',
        LWOWECKI = 'LWOWECKI',
        MILICKI = 'MILICKI',
        OLESNICKI = 'OLESNICKI',
        OLAWSKI = 'OLAWSKI',
        POLKOWICKI = 'POLKOWICKI',
        STRZELINSKI = 'STRZELINSKI',
        SREDZKI_DOLNOSLASKIE = 'SREDZKI_DOLNOSLASKIE',
        SWIDNICKI = 'SWIDNICKI',
        TRZEBNICKI = 'TRZEBNICKI',
        WALBRZYSKI = 'WALBRZYSKI',
        WOLOWSKI = 'WOLOWSKI',
        WROCLAWSKI = 'WROCLAWSKI',
        ZABKOWICKI = 'ZABKOWICKI',
        ZGORZELECKI = 'ZGORZELECKI',
        ZLOTORYJSKI = 'ZLOTORYJSKI',
        BYDGOSZCZ = 'BYDGOSZCZ',
        TORUN = 'TORUN',
        WLOCLAWEK = 'WLOCLAWEK',
        GRUDZIADZ = 'GRUDZIADZ',
        ALEKSANDROWSKI = 'ALEKSANDROWSKI',
        BRODNICKI = 'BRODNICKI',
        BYDGOSKI = 'BYDGOSKI',
        CHELMINSKI = 'CHELMINSKI',
        GOLUBSKO_DOBRZYNSKI = 'GOLUBSKO_DOBRZYNSKI',
        GRUDZIADZKI = 'GRUDZIADZKI',
        INOWROCLAWSKI = 'INOWROCLAWSKI',
        LIPNOWSKI = 'LIPNOWSKI',
        MOGILENSKI = 'MOGILENSKI',
        NAKIELSKI = 'NAKIELSKI',
        RADZIEJOWSKI = 'RADZIEJOWSKI',
        RYPINSKI = 'RYPINSKI',
        SEPOLENSKI = 'SEPOLENSKI',
        SWIECKI = 'SWIECKI',
        TORUNSKI = 'TORUNSKI',
        TUCHOLSKI = 'TUCHOLSKI',
        WABRZESKI = 'WABRZESKI',
        WLOCLAWSKI = 'WLOCLAWSKI',
        ZNINSKI = 'ZNINSKI',
        LUBLIN = 'LUBLIN',
        BIALA_PODLASKA = 'BIALA_PODLASKA',
        CHELM = 'CHELM',
        ZAMOSC = 'ZAMOSC',
        BIALSKI = 'BIALSKI',
        BILGORAJSKI = 'BILGORAJSKI',
        CHELMSKI = 'CHELMSKI',
        HRUBIESZOWSKI = 'HRUBIESZOWSKI',
        JANOWSKI = 'JANOWSKI',
        KRASNOSTAWSKI = 'KRASNOSTAWSKI',
        KRASNICKI = 'KRASNICKI',
        LUBARTOWSKI = 'LUBARTOWSKI',
        LUBELSKI = 'LUBELSKI',
        LECZYNSKI = 'LECZYNSKI',
        LUKOWSKI = 'LUKOWSKI',
        OPOLSKI_LUBELSKIE = 'OPOLSKI_LUBELSKIE',
        PARCZEWSKI = 'PARCZEWSKI',
        PULAWSKI = 'PULAWSKI',
        RADZYNSKI = 'RADZYNSKI',
        RYCKI = 'RYCKI',
        RYKI = 'RYKI',
        SWIDNICKI_LUBELSKIE = 'SWIDNICKI_LUBELSKIE',
        TOMASZOWSKI_LUBELSKIE = 'TOMASZOWSKI_LUBELSKIE',
        WLODAWSKI = 'WLODAWSKI',
        ZAMOJSKI = 'ZAMOJSKI',
        GORZOW_WIELKOPOLSKI = 'GORZOW_WIELKOPOLSKI',
        ZIELONA_GORA = 'ZIELONA_GORA',
        GORZOWSKI = 'GORZOWSKI',
        KROSNIENSKI_LUBUSKIE = 'KROSNIENSKI_LUBUSKIE',
        MIEDZYRZECKI = 'MIEDZYRZECKI',
        NOWOSOLSKI = 'NOWOSOLSKI',
        SLUBICKI = 'SLUBICKI',
        STRZELECKO_DREZDENECKI = 'STRZELECKO_DREZDENECKI',
        SULECINSKI = 'SULECINSKI',
        SWIEBODZINSKI = 'SWIEBODZINSKI',
        ZIELONOGORSKI = 'ZIELONOGORSKI',
        ZAGANSKI = 'ZAGANSKI',
        ZARSKI = 'ZARSKI',
        WSCHOWSKI = 'WSCHOWSKI',
        LODZ = 'LODZ',
        PIOTRKOW_TRYBUNALSKI = 'PIOTRKOW_TRYBUNALSKI',
        SKIERNIEWICE = 'SKIERNIEWICE',
        BELCHATOWSKI = 'BELCHATOWSKI',
        BRZEZINSKI = 'BRZEZINSKI',
        KUTNOWSKI = 'KUTNOWSKI',
        LASKI = 'LASKI',
        LOWICKI = 'LOWICKI',
        LECZYCKI = 'LECZYCKI',
        LODZKI_WSCHODNI = 'LODZKI_WSCHODNI',
        OPOCZYNSKI = 'OPOCZYNSKI',
        PABIANICKI = 'PABIANICKI',
        PAJECZANSKI = 'PAJECZANSKI',
        PIOTRKOWSKI = 'PIOTRKOWSKI',
        PODDEBICKI = 'PODDEBICKI',
        RADOMSZCZANSKI = 'RADOMSZCZANSKI',
        RAWSKI = 'RAWSKI',
        SIERADZKI = 'SIERADZKI',
        SKIERNIEWICKI = 'SKIERNIEWICKI',
        TOMASZOWSKI_LODZKIE = 'TOMASZOWSKI_LODZKIE',
        WIELUNSKI = 'WIELUNSKI',
        WIERUSZOWSKI = 'WIERUSZOWSKI',
        ZDUNSKOWOLSKI = 'ZDUNSKOWOLSKI',
        ZGIERSKI = 'ZGIERSKI',
        KRAKOW = 'KRAKOW',
        NOWY_SACZ = 'NOWY_SACZ',
        TARNOW = 'TARNOW',
        BOCHENSKI = 'BOCHENSKI',
        BRZESKI = 'BRZESKI',
        CHRZANOWSKI = 'CHRZANOWSKI',
        DABROWSKI = 'DABROWSKI',
        GORLICKI = 'GORLICKI',
        KRAKOWSKI = 'KRAKOWSKI',
        LIMANOWSKI = 'LIMANOWSKI',
        MIECHOWSKI = 'MIECHOWSKI',
        MYSLENICKI = 'MYSLENICKI',
        NOWOSADECKI = 'NOWOSADECKI',
        NOWOTARSKI = 'NOWOTARSKI',
        OLKUSKI = 'OLKUSKI',
        OSWIECIMSKI = 'OSWIECIMSKI',
        PROSZOWICKI = 'PROSZOWICKI',
        SUSKI = 'SUSKI',
        TARNOWSKI = 'TARNOWSKI',
        TATRZANSKI = 'TATRZANSKI',
        WADOWICKI = 'WADOWICKI',
        WIELICKI = 'WIELICKI',
        WARSZAWA = 'WARSZAWA',
        RADOM = 'RADOM',
        PLOCK = 'PLOCK',
        SIEDLCE = 'SIEDLCE',
        OSTROLEKA = 'OSTROLEKA',
        BIALOBRZESKI = 'BIALOBRZESKI',
        CIECHANOWSKI = 'CIECHANOWSKI',
        GARWOLINSKI = 'GARWOLINSKI',
        GOSTYNINSKI = 'GOSTYNINSKI',
        GRODZISKI_MAZOWIECKIE = 'GRODZISKI_MAZOWIECKIE',
        GRODZKI_MAZOWIECKI = 'GRODZKI_MAZOWIECKI',
        KOZIENICKI = 'KOZIENICKI',
        LEGIONOWSKI = 'LEGIONOWSKI',
        LIPSKI = 'LIPSKI',
        LOSICKI = 'LOSICKI',
        MAKOWSKI = 'MAKOWSKI',
        MINSKI = 'MINSKI',
        MLAWSKI = 'MLAWSKI',
        NOWODWORSKI = 'NOWODWORSKI',
        OSTROLECKI = 'OSTROLECKI',
        OSTROWSKI_MAZOWIECKIE = 'OSTROWSKI_MAZOWIECKIE',
        OTWOCKI = 'OTWOCKI',
        PIASECZYNSKI = 'PIASECZYNSKI',
        PLOCKI = 'PLOCKI',
        PLONSKI = 'PLONSKI',
        PRASNYSKI = 'PRASNYSKI',
        PRZASNYSKI = 'PRZASNYSKI',
        PRZYSUSKI = 'PRZYSUSKI',
        PULTUSKI = 'PULTUSKI',
        RADOMSKI = 'RADOMSKI',
        SIEDLECKI = 'SIEDLECKI',
        SIERPECKI = 'SIERPECKI',
        SOCHACZEWSKI = 'SOCHACZEWSKI',
        SOKOLOWSKI = 'SOKOLOWSKI',
        SZYDLOWIECKI = 'SZYDLOWIECKI',
        WARSZAWSKI_ZACHODNI = 'WARSZAWSKI_ZACHODNI',
        WEGROWSKI = 'WEGROWSKI',
        WOLOMINSKI = 'WOLOMINSKI',
        WYSZKOWSKI = 'WYSZKOWSKI',
        ZWOLENSKI = 'ZWOLENSKI',
        ZYRARDOWSKI = 'ZYRARDOWSKI',
        ZUROMINSKI = 'ZUROMINSKI',
        OPOLE = 'OPOLE',
        BRZESKI_OPOLSKIE = 'BRZESKI_OPOLSKIE',
        G_UBCZYCKI = 'GŁUBCZYCKI',
        KEDZIERZYNSKO_KOZIELSKI = 'KEDZIERZYNSKO_KOZIELSKI',
        KLUCZBORSKI = 'KLUCZBORSKI',
        KRAPKOWICKI = 'KRAPKOWICKI',
        NAMYSLOWSKI = 'NAMYSLOWSKI',
        NYSKI = 'NYSKI',
        OLESKI = 'OLESKI',
        OPOLSKI = 'OPOLSKI',
        PRUDNICKI = 'PRUDNICKI',
        STRZELECKI = 'STRZELECKI',
        RZESZOW = 'RZESZOW',
        KROSNO = 'KROSNO',
        PRZEMYSL = 'PRZEMYSL',
        TARNOBRZEG = 'TARNOBRZEG',
        BIESZCZADZKI = 'BIESZCZADZKI',
        BRZOZOWSKI = 'BRZOZOWSKI',
        DEBICKI = 'DEBICKI',
        JAROSLAWSKI = 'JAROSLAWSKI',
        JASIELSKI = 'JASIELSKI',
        KOLBUSZOWSKI = 'KOLBUSZOWSKI',
        KROSNIENSKI_PODKARPACKIE = 'KROSNIENSKI_PODKARPACKIE',
        LESKI = 'LESKI',
        LEZAJSKI = 'LEZAJSKI',
        LUBACZOWSKI = 'LUBACZOWSKI',
        LANCUCKI = 'LANCUCKI',
        MIELECKI = 'MIELECKI',
        NIZANSKI = 'NIZANSKI',
        PRZEMYSKI = 'PRZEMYSKI',
        PRZEWORSKI = 'PRZEWORSKI',
        ROPCZYCKO_SEDZISZOWSKI = 'ROPCZYCKO_SEDZISZOWSKI',
        RZESZOWSKI = 'RZESZOWSKI',
        SANOCKI = 'SANOCKI',
        STALOWOWOLSKI = 'STALOWOWOLSKI',
        STRZYZOWSKI = 'STRZYZOWSKI',
        TARNOBRZESKI = 'TARNOBRZESKI',
        BIALYSTOK = 'BIALYSTOK',
        LOMZA = 'LOMZA',
        SUWALKI = 'SUWALKI',
        AUGUSTOWSKI = 'AUGUSTOWSKI',
        BIALOSTOCKI = 'BIALOSTOCKI',
        BIELSKI_PODLASKIE = 'BIELSKI_PODLASKIE',
        GRAJEWSKI = 'GRAJEWSKI',
        HAJNOWSKI = 'HAJNOWSKI',
        KOLNENSKI = 'KOLNENSKI',
        LOMZYNSKI = 'LOMZYNSKI',
        MONIECKI = 'MONIECKI',
        SEJNENSKI = 'SEJNENSKI',
        SIEMIATYCKI = 'SIEMIATYCKI',
        SOKOLSKI = 'SOKOLSKI',
        SUWALSKI = 'SUWALSKI',
        WYSOKOMAZOWIECKI = 'WYSOKOMAZOWIECKI',
        ZAMBROWSKI = 'ZAMBROWSKI',
        GDANSK = 'GDANSK',
        GDYNIA = 'GDYNIA',
        SLUPSK = 'SLUPSK',
        SOPOT = 'SOPOT',
        BYTOWSKI = 'BYTOWSKI',
        CHOJNICKI = 'CHOJNICKI',
        CZLUCHOWSKI = 'CZLUCHOWSKI',
        GDANSKI = 'GDANSKI',
        KARTUSKI = 'KARTUSKI',
        KOSCIERSKI = 'KOSCIERSKI',
        KWIDZYNSKI = 'KWIDZYNSKI',
        LEBORK = 'LEBORK',
        MALBORSKI = 'MALBORSKI',
        NOWODWORSKI_POMORSKIE = 'NOWODWORSKI_POMORSKIE',
        PUCKI = 'PUCKI',
        SLUPSKI = 'SLUPSKI',
        STAROGARDZKI = 'STAROGARDZKI',
        TCZEWSKI = 'TCZEWSKI',
        WEJHEROWSKI = 'WEJHEROWSKI',
        KATOWICE = 'KATOWICE',
        BIELSKO_BIALA = 'BIELSKO_BIALA',
        BYTOM = 'BYTOM',
        CHORZOW = 'CHORZOW',
        CZESTOCHOWA = 'CZESTOCHOWA',
        DABROWA_GORNICZA = 'DABROWA_GORNICZA',
        GLIWICE = 'GLIWICE',
        JASTRZEBIE_ZDROJ = 'JASTRZEBIE_ZDROJ',
        JAWORZNO = 'JAWORZNO',
        MYSLOWICE = 'MYSLOWICE',
        PIEKARY_SLASKIE = 'PIEKARY_SLASKIE',
        RUDA_SLASKA = 'RUDA_SLASKA',
        RYBNIK = 'RYBNIK',
        SIEMIANOWICE_SLASKIE = 'SIEMIANOWICE_SLASKIE',
        SOSNOWIEC = 'SOSNOWIEC',
        SWIETOCHLOWICE = 'SWIETOCHLOWICE',
        TYCHY = 'TYCHY',
        ZABRZE = 'ZABRZE',
        ZORY = 'ZORY',
        BEDZINSKI = 'BEDZINSKI',
        BIELSKI_SLASKIE = 'BIELSKI_SLASKIE',
        CIESZYNSKI = 'CIESZYNSKI',
        CZESTOCHOWSKI = 'CZESTOCHOWSKI',
        GLIWICKI = 'GLIWICKI',
        KLOBUCKI = 'KLOBUCKI',
        LUBLINIECKI = 'LUBLINIECKI',
        MIKOLOWSKI = 'MIKOLOWSKI',
        MYSZKOWSKI = 'MYSZKOWSKI',
        PSZCZY_SKI = 'PSZCZYŃSKI',
        RACIBORSKI = 'RACIBORSKI',
        RYBNICKI = 'RYBNICKI',
        TARNOGORSKI = 'TARNOGORSKI',
        WODZISLAWSKI = 'WODZISLAWSKI',
        ZAWIERCIANSKI = 'ZAWIERCIANSKI',
        ZYWIECKI = 'ZYWIECKI',
        KIELCE = 'KIELCE',
        BUSKI = 'BUSKI',
        JEDRZEJOWSKI = 'JEDRZEJOWSKI',
        KAZIMIERSKI = 'KAZIMIERSKI',
        KIELECKI = 'KIELECKI',
        KONECKI = 'KONECKI',
        OPATOWSKI = 'OPATOWSKI',
        OSTROWIECKI = 'OSTROWIECKI',
        PINCZOWSKI = 'PINCZOWSKI',
        SANDOMIERSKI = 'SANDOMIERSKI',
        SKARZYSKI = 'SKARZYSKI',
        STARACHOWICKI = 'STARACHOWICKI',
        STASZOWSKI = 'STASZOWSKI',
        WLOSZCZOWSKI = 'WLOSZCZOWSKI',
        OLSZTYN = 'OLSZTYN',
        ELBLAG = 'ELBLAG',
        BARTOSZYCKI = 'BARTOSZYCKI',
        BRANIEWSKI = 'BRANIEWSKI',
        DZIALDOWSKI = 'DZIALDOWSKI',
        ELBLASKI = 'ELBLASKI',
        ELK = 'ELK',
        GIZYCKI = 'GIZYCKI',
        ILAWSKI = 'ILAWSKI',
        KETRZYNSKI = 'KETRZYNSKI',
        LIDZBARSKI = 'LIDZBARSKI',
        MRAGOWSKI = 'MRAGOWSKI',
        NIDZICKI = 'NIDZICKI',
        NOWOMIEJSKI = 'NOWOMIEJSKI',
        OLECKI = 'OLECKI',
        OLSZTYNSKI = 'OLSZTYNSKI',
        OSTRODZKI = 'OSTRODZKI',
        PISKI = 'PISKI',
        SZCZYCIENSKI = 'SZCZYCIENSKI',
        WEGORZEWSKI = 'WEGORZEWSKI',
        POZNAN = 'POZNAN',
        KALISZ = 'KALISZ',
        KONIN = 'KONIN',
        LESZNO = 'LESZNO',
        CHODZIESKI = 'CHODZIESKI',
        CZARNKOWSKO_TRZCIANECKI = 'CZARNKOWSKO_TRZCIANECKI',
        GNIEZNIENSKI = 'GNIEZNIENSKI',
        GOSTYNSKI = 'GOSTYNSKI',
        GRODZISKI_WIELKOPOLSKIE = 'GRODZISKI_WIELKOPOLSKIE',
        JAROCINSKI = 'JAROCINSKI',
        KALISKI = 'KALISKI',
        KEPINSKI = 'KEPINSKI',
        KOLSKI = 'KOLSKI',
        KONINSKI = 'KONINSKI',
        KOSCIANSKI = 'KOSCIANSKI',
        KROTOSZYNSKI = 'KROTOSZYNSKI',
        LESZCZYNSKI = 'LESZCZYNSKI',
        MIEDZYCHODZKI = 'MIEDZYCHODZKI',
        NOWOTOMYSKI = 'NOWOTOMYSKI',
        OBORNICKI = 'OBORNICKI',
        OSTROWSKI_WIELKOPOLSKIE = 'OSTROWSKI_WIELKOPOLSKIE',
        OSTRZESZOWSKI = 'OSTRZESZOWSKI',
        PILSKI = 'PILSKI',
        PLESZEWSKI = 'PLESZEWSKI',
        POZNANSKI = 'POZNANSKI',
        RAWICKI = 'RAWICKI',
        SLUPECKI = 'SLUPECKI',
        SZAMOTULSKI = 'SZAMOTULSKI',
        SREDZKI_WIELKOPOLSKIE = 'SREDZKI_WIELKOPOLSKIE',
        SREMSKI = 'SREMSKI',
        TURECKI = 'TURECKI',
        WAGROWIECKI = 'WAGROWIECKI',
        WOLSZTYNSKI = 'WOLSZTYNSKI',
        WRZESINSKI = 'WRZESINSKI',
        ZLOTOWSKI = 'ZLOTOWSKI',
        SZCZECIN = 'SZCZECIN',
        KOSZALIN = 'KOSZALIN',
        SWINOUJSCIE = 'SWINOUJSCIE',
        BIALOGARD = 'BIALOGARD',
        CHOSZCZENSKI = 'CHOSZCZENSKI',
        DRAWSKI = 'DRAWSKI',
        GOLENIOWSKI = 'GOLENIOWSKI',
        GRYFICKI = 'GRYFICKI',
        GRYFINSKI = 'GRYFINSKI',
        KAMIENSKI = 'KAMIENSKI',
        KOLOBRZESKI = 'KOLOBRZESKI',
        KOSZALINSKI = 'KOSZALINSKI',
        LOBESKI = 'LOBESKI',
        MYSLIBORSKI = 'MYSLIBORSKI',
        POLICKI = 'POLICKI',
        PYRZYCKI = 'PYRZYCKI',
        SLAWIENSKI = 'SLAWIENSKI',
        STARGARDZKI = 'STARGARDZKI',
        SZCZECINECKI = 'SZCZECINECKI',
        SWIDWINSKI = 'SWIDWINSKI',
        WALECKI = 'WALECKI',
    }
    export enum teamType {
        SENIOR = 'SENIOR',
        YOUTH = 'YOUTH',
    }
    export enum userType {
        SPORTS_CLUB = 'SPORTS_CLUB',
        COACH = 'COACH',
        PLAYER = 'PLAYER',
    }
}

